import EditEditor from "./EditEditor";

export default EditEditor;



// WEBPACK FOOTER //
// ./src/components/RevvEditor/index.js